export enum SupportTicketStatusEnum {
    OPEN = 'OPEN',
    CLOSED = 'CLOSED',
}
